<template>
  <div class="w100 video-container">
    <iframe width="560" height="315" :src="`https://www.youtube.com/embed/${id}`" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
  </div>
</template>

<script>
  export default {
    name: "videoPlayer",
    props: ['id'],

  }
</script>

<style scoped>

  .video-container {
    position: relative;
    padding-top: 0px;
    padding-bottom: 56.25%;
    height:0;
    overflow: hidden;
    margin-bottom: 2rem;
  }
 .video-container iframe {
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;


  }
</style>




// WEBPACK FOOTER //
// src/components/blocks/VideoPlayer.vue